<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>新闻公告管理</h3></div>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="desc" label="内容">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="
              showContent = scope.row.desc;
              isContentShow = true;
            "
          >
            点击预览
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="c_time" label="公告时间"></el-table-column>
      <el-table-column prop="sort" label="排序"></el-table-column>

      <el-table-column fixed="right" width="180">
        <template slot="header" slot-scope="scope">
          <el-button
            @click="
              noticesInfo = {};
              isShow = true;
            "
            type="primary"
            size="small"
          >
            发布公告
          </el-button>
        </template>
        <template slot-scope="scope">
          <el-button
            @click="
              noticesInfo = scope.row;
              defaultContent = scope.row.desc;
              isShow = true;
            "
            type="primary"
            size="small"
          >
            编辑
          </el-button>
          <el-button
            @click="handleDeleteNotices(scope.row.id)"
            type="danger"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="查看"
      :visible.sync="isContentShow"
      show-close
      :fullscreen="UI.isMobile"
    >
      <div v-html="showContent"></div>
    </el-dialog>

    <el-dialog
      title="发布公告"
      :visible.sync="isShow"
      :fullscreen="UI.isMobile"
      show-close
      v-if="isShow"
    >
      <div class="flex flex-direction align-center noticesInfo">
        <el-form
          ref="noticesInfoForm"
          :model="noticesInfo"
          :rules="noticesInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'"
          :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;"
        >
          <el-form-item label="公告标题" prop="title">
            <el-input
              placeholder="请输入标题"
              clearable
              v-model="noticesInfo.title"
            ></el-input>
          </el-form-item>

          <el-form-item label="公告时间" prop="c_time">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="noticesInfo.c_time"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
            <el-input-number
              placeholder="请输入排序"
              clearable
              :min="0"
              :max="9999"
              v-model="noticesInfo.sort"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="公告内容" prop="desc">
            <ParseEdit
              ref="edit"
              @onChange="editOnChange"
              :defaultContent="defaultContent"
            ></ParseEdit>
          </el-form-item>
        </el-form>

        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="submit()"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getNoticesList, addNotices, deleteNotices } from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import ParseEdit from '@/components/parseEdit.vue';

export default {
  components: {
    ParseEdit,
  },

  data() {
    return {
      isContentShow: false,
      showContent: '',
      defaultContent: '',
      noticesInfo: {},
      isShow: false,
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      noticesInfoRules: {
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        desc: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'blur',
          },
        ],
        sort: [
          {
            required: true,
            message: '请输入排序',
            trigger: 'blur',
          },
        ],
        c_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      this.page = 1;
      getNoticesList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    editOnChange: function(content) {
      this.noticesInfo.desc = content;
    },

    handleDeleteNotices: function(fileId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deleteNotices(fileId, function(res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    submit: function() {
      let that = this;
      this.$refs.noticesInfoForm.validate((valid) => {
        if (valid) {
          addNotices(this.noticesInfo, function(res) {
            that.noticesInfo = {};
            that.isShow = false;
            that.flushData();
            showSuccessMsg(res);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.noticesInfo {
  .el-form-item__content {
    line-height: unset !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/homepage/notices.vue